import React, { Component } from 'react';
import * as mat from 'material-ui';
import { connect } from 'react-redux';
// import FaCheck from 'react-icons/lib/fa/check'
// // import { FetchDetailsQuiz } from '../actions/detailAction';
// import firebase from 'firebase';
// import dummy from './images/Magelogoorig.png';
// import hear from './images/hear_icon.png';
// import write from './images/write_icon.png';
// import speak from './images/speak_icon.png';
// import read from './images/read_icon.png';
// // import { browserHistory } from 'react-router';
// import { scoreViewAction } from '../actions/scoresAction'
// import ReactAudioPlayer from 'react-audio-player';
// import quizStart from './music/bensound-funkyelement.mp3'
// import correctBell from './music/Correct-answer.mp3'
import './style.css'



class Timer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            timer: 0
        }
    }
    intervalTime;
    componentDidMount() {
        console.log('a', this.props)
        let timeToEnd = this.props.TimerToStart;
        timeToEnd = timeToEnd.replace(' Sec', '');
        this.setState({
            timer: timeToEnd
        })
        this.intervalTime = setInterval(() => {
            // console.log(this.state.timer, 'timer', this.props.currentState.timeToEnd);
            if (this.state.timer === 0) {
                this.props.currentState.setState({
                    // timerToEndState: undefined

                    nextButton: true,
                    flagforTimer: false,
                    correct: true,
                    quizStarts: false
                })
                clearInterval(this.intervalTime);

            }
            else {
                console.log(this.state.timer - 1)
                this.setState({
                    timer: this.state.timer - 1
                })
            }
        }, 1000)

    }
    componentWillUnmount() {
        console.log('clear time');
        clearInterval(this.intervalTime);

    }
    componentWillReceiveProps(nextProps) {
        console.log(nextProps, 'nextProps++----------')
    }
    render() {
        return (
            <div>
                {this.state.timer}
            </div>
        )
    }

}
const mapStateToProps = (state) => {
    return {
        // quizQuestions: state.DetailReducers.QuizQuestions,
        // gameKey: state.PlayingReducer.gameRomData,
        // currentQuiz: state.PlayingReducer.currentQuiz
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        // FetchDetailsQuiz: (quizKey) => {
        //     dispatch(FetchDetailsQuiz(quizKey));
        // },
        // scoreViewAction: (gameKeyClone) => {
        //     dispatch(scoreViewAction(gameKeyClone))
        // }

    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Timer);


// WEBPACK FOOTER //
// ./src/component/timer.js